import React from 'react';
import {
  CampaignSpec,
  CampaignType,
  FirstPaymentCampaignSpec,
  V2MemberCampaignSpec,
} from '../../../types/membershipPlans';
import classNames from 'classnames';
import './campaignListItem.module.scss';
import { DetailedDateTime } from '@sheinc/design-system';
import { MaterialFontIcon } from '../../../../commonv3/components/atoms/icons/icons';
import { NonSpOnly, SpOnly } from '../../../../commonv3/components/atoms/layouts/visibility';

const BaseCampaignCard = ({
  title,
  expiresAt,
  benefitText,
  onClick = undefined,
}: {
  title: string;
  expiresAt: string;
  benefitText: React.ReactNode;
  onClick?: () => void;
}) => (
  <div styleName={classNames('item')} onClick={onClick}>
    <div styleName="item-left">
      <div styleName="item-name">{title} 適用中!</div>
      <NonSpOnly>
        <div styleName="item-expires-at">
          <MaterialFontIcon name="timer" styleName="timer-icon" />
          <DetailedDateTime date={expiresAt} />
          まで
        </div>
      </NonSpOnly>
    </div>
    <div styleName="item-right">
      <div styleName="item-benefit-text">{benefitText}</div>
    </div>
    <SpOnly>
      <div styleName="item-expires-at">
        <MaterialFontIcon name="timer" styleName="timer-icon" />
        <DetailedDateTime date={expiresAt} />
        まで
      </div>
    </SpOnly>
  </div>
);

export const FirstPaymentCampaign = ({ campaign }: { campaign: FirstPaymentCampaignSpec }) => {
  return (
    <BaseCampaignCard
      title={campaign.name}
      expiresAt={campaign.expires_at}
      benefitText={
        <span>
          初回お支払いから
          <span styleName="off">{campaign.amount.toLocaleString()}円OFF</span>
        </span>
      }
    />
  );
};

export const V2MemberCampaign = ({ campaign }: { campaign: V2MemberCampaignSpec }) => {
  return (
    <BaseCampaignCard
      title="新プラン移行割引"
      expiresAt={campaign.expires_at}
      benefitText={
        <span>
          {campaign.available_tickets}枚所持→{campaign.free_trial_months}ヶ月無料
        </span>
      }
    />
  );
};

type Props = {
  campaign: CampaignSpec;
};

export const CampaignListItem = ({ campaign }: Props) => {
  switch (campaign.type) {
    case CampaignType.FIRST_PAYMENT:
      return <FirstPaymentCampaign campaign={campaign} />;
    case CampaignType.V2_MEMBER:
      return <V2MemberCampaign campaign={campaign} />;
    default:
      return null;
  }
};
